tailwind.config = {
            theme: {
                extend: {
                    colors: {
                        baby: {
                            50: '#f0f9ff',
                            100: '#e0f2fe',
                            200: '#bae6fd',
                            500: '#0284c7',
                            600: '#0369a1',
                            700: '#075985',
                            warm: '#fffbeb',
                            accent: '#f43f5e',
                            softBg: '#f8fafc',
                            cardBorder: '#e2e8f0'
                        }
                    },
                    fontFamily: {
                        sans: ['Noto Sans SC', 'sans-serif'],
                    }
                }
            }
        }
